<div class="not-found">
  <section class="not-found-content-wrapper">
    <img
      [ngSrc]="'assets/images/broken_paper.svg'"
      [width]="111"
      [height]="100"
      alt="broken paper"
      class="not-found__illustration"
    />
    <h1 class="not-found__title">Oups ! Page introuvable</h1>
    <p class="not-found__description">
      La page que vous recherchez n'existe pas ou a été déplacée.
    </p>
    <a routerLink=".." button size="md"> Retour à l'accueil </a>
  </section>
</div>
